import { Route, Routes } from "react-router-dom";

import { DeviceDatasets } from "./DeviceDatasets";
import { DeviceDetails } from "./DeviceDetails";
import { DeviceFiles } from "./DeviceFiles";
import { DeviceTokens } from "./DeviceTokens";

interface DeviceTabRoutesProps {
  deviceId: string;
}

export function DeviceTabRoutes({ deviceId }: DeviceTabRoutesProps) {
  return (
    <Routes>
      <Route path="details" element={<DeviceDetails deviceId={deviceId} />} />
      <Route path="tokens" element={<DeviceTokens deviceId={deviceId} />} />
      <Route path="datasets" element={<DeviceDatasets deviceId={deviceId} />} />
      <Route path="files" element={<DeviceFiles deviceId={deviceId} />} />
      <Route path="*" element={<DeviceDatasets deviceId={deviceId} />} />
    </Routes>
  );
}
